import { configureStore } from "@reduxjs/toolkit";
import { productSlice, articleSlice, canjeSlice, clienteSlice, articulosKioskSlice } from "./";
import stockControlReducer from "./stockControl/stockControlSlice";
import configuracionReducer from "./configuracion/configuracionSlice";
import depositosReducer from "./depositos/depositosSlice";
import scannerModalReducer from "./scannerModal/scannerModalSlice";

export const store = configureStore({
  reducer: {
    product: productSlice.reducer,
    article: articleSlice.reducer,
    canje: canjeSlice.reducer,
    cliente: clienteSlice.reducer,
    articulosKiosk: articulosKioskSlice.reducer,
    stockControl: stockControlReducer,
    configuracion: configuracionReducer,
    depositos: depositosReducer,
    scannerModal: scannerModalReducer,
  },
});
